// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const HighRentalDaysItem = props =>
    <div className='high-rental-days-item'>
        <div className='count'>
            {props.count}
        </div>
        <div className='status'>
            <FormattedMessage id={props.status}/>
        </div>
        <div className='status-indicator'>
            <span
                className={props.className}
                onClick={props.onExport}
            />
        </div>
    </div>;

HighRentalDaysItem.displayName = 'HighRentalDaysItem';
HighRentalDaysItem.propTypes = {
    className: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    onExport: PropTypes.func.isRequired,
    status: PropTypes.string.isRequired
};

export default HighRentalDaysItem;



// WEBPACK FOOTER //
// ./src/product/search/components/high-rental-days-item.js